import React from "react";
import classes from "./priceSummary.module.css";
import { FaRupeeSign } from "react-icons/fa";

const ShippingSummary = (props) => {
  const { data } = props;

  if (!data.length || !data[0].selected_shipping_method) {
    return null;
  }

  const shipping = data[0].selected_shipping_method.amount;

  const price = shipping.value ? (
    <>
      <FaRupeeSign />
      <span>{shipping.value}</span>
    </>
  ) : (
    <span>
      <span>FREE</span>
    </span>
  );

  return (
    <>
      <span className={classes.lineItemLabel}>
        <h6>Shipping Charges</h6>
      </span>
      <span className={classes.price}>{price}</span>
    </>
  );
};

export default ShippingSummary;
